<div class="min-h-screen">
  @if(loading)
  {
  <div class="min-h-screen flex justify-center items-center w-full bg-black/80 dark:bg-black/85 bg-blend-color">
    <span class="loading loading-spinner text-secondary"></span>
  </div>
  }
  @else {

  <div class="container flex md:flex-row flex-col-reverse gap-3">
    <div
      class="info flex flex-col self-stretch gap-3 md:w-4/6 p-4  bg-gradient-to-r from-base-200 to-base-300 rounded-2xl">
      <h2 class=" text-2xl font-bold">{{movieDetails.original_title}}</h2>
      <div class="flex items-center gap-2 justify-between">
        <div class="rate flex items-center text-warning text-shadow-xs">
          <ng-icon name="solarStarBold" />
          <span class=" font-semibold">{{(movieDetails.popularity%10)
            <5?((movieDetails.popularity%10)+5).toFixed(1):(movieDetails.popularity%10).toFixed(1)}} </span>
        </div>
        <h2 class="text-neutral/50 font-bold">{{movieDetails.release_date}}</h2>
      </div>
      <h2 class="font-bold text-accent text-xl">Overview</h2>
      <p class=" text-base-content max-w-lg">{{movieDetails.overview}}</p>
      <!-- TrailerLink -->
      <a [href]="trailerLink" target="_blank" rel="noopener noreferrer" class=" link link-primary">
        <i class="fa-solid fa-link"></i>
        Explore Trailer
      </a>

      <div class="categories flex flex-wrap gap-2">
        @for (category of movieCats; track $index) {
        <div class=" badge badge-accent text-xs font-semibold ">
          {{category}}
        </div>
        }
      </div>
      <h3 class="text-3xl text-end font-bold text-primary text-shadow-xs">{{formatCurrency(movieDetails.price)}}</h3>
      <div class="flex-1"></div>
      <!-- Buttons - positioned at the bottom with -->
      <div class="flex flex-col sm:flex-row gap-4 my-3">
        <button class="btn btn-secondary " (click)="addToWatchList()">
          @if (isInWatchList()) {
          <ng-icon name="faSolidBookmark" />
          Remove from WatchList
          }@else {
          <ng-icon name="faBookmark" />
          Add to WatchList
          }
        </button>
        <button class="btn sm:flex-1 btn-primary" (click)="addToCart()">
          <ng-icon name="faSolidCartShopping" class="text-white" />
          {{ isInCart() ? 'Remove from Cart' : 'Add to Cart' }}
        </button>
      </div>

    </div>
    <img class="md:w-2/6 w-full rounded-2xl aspect-[3/4] object-cover" src={{getImageSrc()}}
      alt='{{movieDetails.poster_path}}' />
  </div>

  <div class="container movies-sec my-3">
    <h2 class="relative text-lg font-bold pb-2 border-b-4 border-secondary">
      Related Movies</h2>
    <div class="related-movies grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 my-4">
      <div class="item max-w-50" *ngFor="let movie of displayedRelatedMovies ; let i =index">
        <app-mediaCard [mediaItem]="movie"></app-mediaCard>
      </div>
    </div>
  </div>


  }

</div>